import {Cookies} from "react-cookie";
import Constants from "../configs/Constants";
import i18n from "../i18n";
import {showErrorBox} from "../components/MessageBox";
import {hideProgress, showProgress} from "../components/ProgressCustom";
import moment from "moment";
import {LocalStorage} from "./StorageUtil";
import {hideProgressFooter, showProgressFooter} from "../components/DefaultLayout/DefaultFooter";

const cookie = new Cookies();

const RestAPIHelper = {
    get(_url, _callback, hasDialogProcess = false, _error = error => {
    }) {
        return fetch(_url, {
            method: "GET",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
                Authorization: "Bearer " + cookie.get(Constants.STORAGE_KEY.TOKEN_LOGGED),
                request_pair: moment().format("YYYYMMDDHHmmssSSS"),
                app_code: Constants.APP_ID,
            },
        }).then(response => {
            if (response.ok) {
                return response.json();
            } else {
                throw response;
            }
        }).then(responseJson => {
            return this.handlingResponse(responseJson, hasDialogProcess, _callback);
        }).catch(response => {
            this.handlingError(response, hasDialogProcess, _error);
        });
    },

    post(
        _url,
        _params,
        _callback,
        hasDialogProcess = false,
        _error = error => {}) {
        return fetch(_url, {
            method: "POST",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
                Authorization: "Bearer " + cookie.get(Constants.STORAGE_KEY.TOKEN_LOGGED),
                request_pair: moment().format("YYYYMMDDHHmmssSSS"),
                app_code: Constants.APP_ID,
                //sessionId: LocalStorage.getItem(Constants.STORAGE_KEY.SESSION_ID)
            },
            body: JSON.stringify(_params),
        }).then(response => {
            if (response.ok) {
                return response.json();
            } else {
                throw response;
            }
        }).then(responseJson => {
            return this.handlingResponse(responseJson, hasDialogProcess, _callback);
        }).catch(response => {
            this.handlingError(response, hasDialogProcess, _error);
        });
    },

    login(
        _callback,
        _params,
        _error = error => {
        }) {
        showProgress();
        return fetch(Constants.LOGIN_URL + "auth/login", {
            method: "POST",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
                request_pair: moment().format("YYYYMMDDHHmmssSSS"),
                app_code: process.env.REACT_APP_CODE
            },

            body: JSON.stringify(_params)
        }).then(response => {
            if (response.ok) {
                return response.json();
            } else {
                throw response;
            }
        }).then(responseJson => {
            return this.handlingResponseLogin(responseJson, true, _callback);
        }).catch(response => {
            this.handlingError(response, true, _error);
        });
    },
    handlingResponseLogin(responseJson, hasDialogProcess, callback) {
        if (hasDialogProcess) {
            hideProgress();
        }
        if (responseJson.code === Constants.RESPONSE_STATUS.SUCCESS) {
            if (callback) {
                callback(responseJson);
            }
            return responseJson;
        } else if (responseJson.code === Constants.RESPONSE_CODE.EXCEPTION) {
            showErrorBox(responseJson.message);
        }
    },
    handlingResponse(responseJson, hasDialogProcess, callback) {
        if (hasDialogProcess) {
            hideProgress();
        }
        if (responseJson.status === Constants.RESPONSE_STATUS.SUCCESS || responseJson.status === Constants.RESPONSE_STATUS.API_000) {
            if (callback) {
                callback(responseJson);
            }
            return responseJson;
        } else if (responseJson.status === Constants.RESPONSE_STATUS.ERROR_WITH_PAR) {
            let mess = i18n.t("common.error." + responseJson.code);
            responseJson.paramCode.forEach((value, index) => {
                mess = mess.replace(":" + index, value);
            });
            showErrorBox(mess);
        } else {
            if (responseJson.code !== Constants.RESPONSE_CODE.EXCEPTION) {
                showErrorBox(i18n.t("common.error." + responseJson.code));
            } else {
                showErrorBox(i18n.t("common.error." + responseJson.data.message));
            }
        }
    },
    handlingError(response, hasDialogProcess, callback) {
        if (response.status === 500) {
            showErrorBox(i18n.t("common.error.SERVER_ERR"));
        } else if (response.status === 401 || response.status === 403) {
            let d = new Date();
            d.setTime(d.getTime() + 24 * 60 * 60 * 1000);
            cookie.set(Constants.STORAGE_KEY.SESSION_EXPIRED, true, {
                path: '/',
                expires: d
            });
            showErrorBox(i18n.t("common.error.TOKEN_ERR"));
            setTimeout(() => {
                cookie.remove(Constants.STORAGE_KEY.TOKEN_LOGGED);
                LocalStorage.removeItem(Constants.STORAGE_KEY.TOKEN_LOGGED);
                window.open(`${process.env.PUBLIC_URL}/Login`, "_self");
            }, 5000);
        } else {
            showErrorBox(i18n.t("common.error.PROCESS_ERR"));
        }
        if (hasDialogProcess) {
            hideProgress();
        }
        callback(response);
    },

    getSiteMap(_url, _callback, hasDialogProcess = false, _error = error => {
    }) {
        return fetch(_url, {
            method: "GET",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
                Authorization: "Bearer " + cookie.get(Constants.STORAGE_KEY.TOKEN_LOGGED),
                request_pair: moment().format("YYYYMMDDHHmmssSSS"),
                app_code: process.env.REACT_APP_CODE
            }
        }).then(response => {
            if (response.ok) {
                return response.json();
            } else {
                throw response;
            }
        }).then(responseJson => {
            return this.handlingResponseSiteMap(responseJson, hasDialogProcess, _callback);
        }).catch(response => {
            this.handlingError(response, hasDialogProcess, _error);
        });
    },

    handlingResponseSiteMap(responseJson, hasDialogProcess, callback) {
        if (responseJson.code === Constants.RESPONSE_STATUS.API_000) {
            if (callback) {
                callback(responseJson);
            }
            return responseJson;
        } else {
            if (responseJson.code !== Constants.RESPONSE_CODE.EXCEPTION) {
                showErrorBox(i18n.t("common.error." + responseJson.code));
            } else {
                showErrorBox(responseJson.message);
            }
        }
    },
    delete(
        _url,
        _params,
        _callback,
        hasDialogProcess = false,
        _error = error => {
        }) {
        return fetch(_url, {
            method: "DELETE",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
                Authorization: "Bearer " + cookie.get(Constants.STORAGE_KEY.TOKEN_LOGGED),
                request_pair: moment().format("YYYYMMDDHHmmssSSS"),
                app_code: process.env.REACT_APP_CODE
            },
            body: JSON.stringify(_params)
        }).then(response => {
            if (response.ok) {
                return response.json();
            } else {
                throw response;
            }
        }).then(responseJson => {
            return this.handlingResponse(responseJson, hasDialogProcess, _callback);
        }).catch(response => {
            this.handlingError(response, hasDialogProcess, _error);
        });
    },
    getSSO(_url, _callback, hasDialogProcess = false, _error = error => {
    }) {
        if (hasDialogProcess) {
            hideProgress();
        } else {
            showProgressFooter();
        }
        return fetch(_url, {
            method: "GET",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
                Authorization: "Bearer " + cookie.get(Constants.STORAGE_KEY.TOKEN_LOGGED),
                request_pair: moment().format("YYYYMMDDHHmmssSSS"),
                app_code: Constants.APP_ID,
                //sessionId: LocalStorage.getItem(Constants.STORAGE_KEY.SESSION_ID)
            },
            credentials: "include"
        })
            .then(response => {
                if (response.ok) {
                    return response.json();
                } else {
                    throw response;
                }
            })
            .then(responseJson => {
                return this.handlingResponse(responseJson, hasDialogProcess, _callback);
            })
            .catch(response => {
                this.handlingError(response, hasDialogProcess, _error);
            });
    },

    postSSO(
        _url,
        _params,
        _callback,
        hasDialogProcess = false,
        _error = error => {
            console.error(error);
        }
    ) {
        if (hasDialogProcess) {
            showProgress();
        }
        return fetch(_url, {
            method: "POST",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
               // Authorization: "Bearer " + cookie.get(Constants.STORAGE_KEY.TOKEN_LOGGED),
                request_pair: moment().format("YYYYMMDDHHmmssSSS"),
                app_code: Constants.APP_ID,
                //sessionId: LocalStorage.getItem(Constants.STORAGE_KEY.SESSION_ID)
            },
            body: JSON.stringify(_params),
            credentials: "include"
        })
            .then(response => {
                if (response.ok) {
                    return response.json();
                } else {
                    throw response;
                }
            })
            .then(responseJson => {
                return this.handlingResponse(responseJson, hasDialogProcess, _callback);
            })
            .catch(response => {
                this.handlingError(response, hasDialogProcess, _error);
            });
    },

};
export default RestAPIHelper;
